//src/app/features/conversations/Components/ConversationsList/index.tsx
import { ScrollContainer } from 'app/layout/dashboardLayout/BoxLayout';
import {
  ArchivedConversationsIcon,
  ComposeConversationIcon,
  StarredConversationsIcon,
} from 'assets/icons';
import DebouncedSearch from 'Components/DebouncedSearch';
import PaginatedList from 'Components/Pagination/PaginatedList';

import LoadingSpinner from 'Components/Spinner/LoadingSpinner';
import { Link, useParams } from 'react-router-dom';
import { useConversationsList } from '../../Hooks/useConversationsList';
import ConversationThumbnail from '../ConversationThumbnail';
import { EyeIcon as ReadConversationsIcon } from 'assets/icons';

export default function ConversationsList({
  width = 'w-full',
}: {
  width?: string;
}) {
  const {
    data,
    params: { filters },
    toggleIsStared,
    setSearch,
    toggleIsArchived,
    toggleIsRead,
    hasMore,
    isLoading,
    loadMore,
  } = useConversationsList();

  const { archived, stared, read, title_search } = filters;
  const { clientId } = useParams();

  return (
    <ScrollContainer
      width={width}
      className={`border-r border-gray-dark border-opacity-10`}
    >
      <div className="flex h-20 shrink-0 justify-between items-center px-4 py-6 border-b border-gray-dark border-opacity-10">
        <div className=" col-span-2 text-gray-dark font-extrabold">
          Messages
        </div>

        <div className="flex gap-x-2 relative">
          {!clientId && (
            <>
              <div
                className="relative group cursor-pointer"
                onClick={toggleIsRead}
              >
                <ReadConversationsIcon
                  className={`w-7 h-7 border-2 rounded ${
                    read
                      ? 'bg-white text-white border-green'
                      : 'text-green bg-wihte border-white'
                  }`}
                />
                <span className="absolute left-1/2 -translate-x-1/2 bottom-full mb-1 bg-gray-700 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                  Mark as Read
                </span>
              </div>
              <div
                className="relative group cursor-pointer"
                onClick={toggleIsStared}
              >
                <StarredConversationsIcon
                  className={`w-7 h-7 ${
                    stared ? 'bg-green text-white' : 'text-green bg-wihte'
                  }`}
                />
                <span className="absolute left-1/2 -translate-x-1/2 bottom-full mb-1 bg-gray-700 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                  Mark as Bookmarked
                </span>
              </div>
              <div
                className="relative group cursor-pointer"
                onClick={toggleIsArchived}
              >
                <ArchivedConversationsIcon
                  className={`w-7 h-7 ${
                    archived ? 'bg-green text-white' : 'text-green bg-wihte'
                  }`}
                />
                <span className="absolute left-1/2 -translate-x-1/2 bottom-full mb-1 bg-gray-700 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                  Archive
                </span>
              </div>
            </>
          )}

          <Link to="compose" className="relative group">
            <ComposeConversationIcon className={`w-7 h-7`} />
            <span className="absolute left-1/2 -translate-x-1/2 bottom-full mb-1 bg-gray-700 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity">
              Compose
            </span>
          </Link>
        </div>
      </div>

      <div className="flex py-2 items-center border-b border-gray-dark border-opacity-10 text-xs">
        <DebouncedSearch
          className="border-none text-sm"
          onChange={setSearch}
          placeholder={'Search for Messages'}
        />
      </div>

      <ScrollContainer>
        {/* intentionally wraped the list in a an empty <div> 
          to let the content scroll while mantaining a fixed 
          header while keeping the loader out of view */}
        <div>
          <PaginatedList
            gapItems={false}
            notFoundTitle=""
            notFoundSubTitle="No messages found"
            Item={ConversationThumbnail}
            data={data}
            isLoading={isLoading}
          />
        </div>
        <LoadingSpinner active={hasMore} loadMore={loadMore} />
      </ScrollContainer>
    </ScrollContainer>
  );
}
